import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import ImageUploader from 'apps/ask/components/ImageUploader';
import CircleArrowButton from 'apps/ask/components/CircleArrowButton';

const HomeSlide = ({ children, number, active, onImageUpload, onLeaveButtonClick, style }) => (
  <div className={cx('slide', `slide--${number}`, { 'slide--active': active })} style={style}>
    <div className="container">
      <div className="slide__content slide-up-fade-in">
        {children}
        <ImageUploader
          className="button button--gradient button--large get-started-button"
          label="Get Started"
          onUpload={onImageUpload}
        />
      </div>
    </div>
    <CircleArrowButton className="slide__leave-button" direction="down" onClick={onLeaveButtonClick} />
  </div>
);

HomeSlide.defaultProps = {
  active: false,
  style: {}
};

HomeSlide.propTypes = {
  onLeaveButtonClick: PropTypes.func.isRequired,
  onImageUpload: PropTypes.func.isRequired,
  active: PropTypes.bool,
  number: PropTypes.number.isRequired,
  children: PropTypes.any.isRequired,
  style: PropTypes.object
};

export default HomeSlide;
